import { jsx } from "react/jsx-runtime";
import { Radio } from "antd";
import { rootClass } from "./constant.js";
function Button(props) {
    return /*#__PURE__*/ jsx(Radio.Button, {
        ...props,
        className: rootClass
    });
}
export { Button as default };
